import React from "react";
import { RouteComponentProps } from "@reach/router";
import Matches from "../matches-tab";

type PageMatchesProps = RouteComponentProps;

const PageMatches: React.FC<PageMatchesProps> = () => {
  return <Matches />;
};

export default PageMatches;
